import { Injectable } from "@angular/core";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../../../../../environments/environment";
import * as HSET from "../settings";
import { GenericHttpService } from "../../../../services/generic-http.service";
import { Observable } from "rxjs";
import { $ } from "protractor";

@Injectable()
export class ReasonForFailureService {
  apiUrl = environment.gateWayHost;
  editItem: any;
  constructor(public generic: GenericHttpService) {}

  getReasonForFailureData(url, params): Observable<any> {
    const option = {
      method: "GET",
      url: `${this.apiUrl}${url}`,
      query: params
    };
    return this.generic.httpRequest(option).pipe(
      catchError(this.generic.handleError),
      map(this.processReasonForFailure)
    );
  }

  processPartForChart(part) {}

  processReasonForFailure(data: any) {
    let total = data.data.reduce((sum, obj) => {
      return sum + obj.failure;
    }, 0);
    total = Number(total);
    const series = data.data.map(obj => [
      obj.failure_reason.charAt(0).toUpperCase() + obj.failure_reason.slice(1),
      Number(obj.quantity.toFixed(0))
    ]);
    total = total.toFixed(0);
    return { series, total };
  }
  createChart(chartData, Options) {
    const chart = JSON.parse(JSON.stringify(HSET.chartData));
    chart.series[0].data = chartData.series;
    chart.title.text = `<div style = "text-align:center;">
       <strong style = "font-size:30px">${chartData.total}</strong>
       <br/>${Options.dataText}</div>`;

    // if (chartData.series.length > 1) {
    //   chart.title.text = `<div style = "text-align:center;">
    //   <strong style = "font-size:30px">${chartData.total}</strong>
    //   <br/>${Options.dataText}</div>`;
    // } else {
    //   chart.title.text = `<div style = "text-align:center;">
    //   <strong style = "font-size:30px">${chartData.series[0][1]}</strong>
    //   <br/>${Options.dataText}</div>`;
    // }


    return chart;
  }
}
